var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03105 11.7478C0.837413 11.5541 0.728638 11.2913 0.728638 11.0174C0.728638 10.7434 0.837413 10.4807 1.03105 10.2869L10.4408 0.875865C10.6304 0.685526 10.8867 0.576509 11.1553 0.571928C11.4239 0.567346 11.6838 0.66756 11.8798 0.851323L12.1613 1.11741C12.2614 1.2118 12.3415 1.32522 12.3971 1.451C12.4528 1.57677 12.4827 1.71239 12.4852 1.84989C12.4878 1.9874 12.4628 2.12402 12.4119 2.25176C12.3609 2.37949 12.285 2.49577 12.1885 2.59378L3.89597 11.0167L12.1962 19.3958C12.2923 19.4928 12.3683 19.6079 12.4196 19.7345C12.471 19.861 12.4968 19.9965 12.4954 20.1331C12.4941 20.2696 12.4657 20.4046 12.4119 20.5301C12.3581 20.6556 12.28 20.7693 12.182 20.8644L11.8811 21.1576C11.6864 21.3467 11.4251 21.4517 11.1537 21.4497C10.8822 21.4478 10.6225 21.3392 10.4305 21.1473L1.03105 11.7478Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.f6fadc03b3554452022297bdb73671dd.svg";
export { ForwardRef as ReactComponent };